import TopFooter from './top-footer/top-footer';
import './footer.scss';
import BottomFooter from './bottom-footer/bottom-footer';
import React from 'react';

function Footer() {
  return (
    <div className="Footer">
      <TopFooter />
      <BottomFooter />
    </div>
  );
}

export default Footer;
